import React, { useState } from "react";
import { Card, CardBody, Nav, NavItem, NavLink, Button } from "reactstrap";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import FeatherIcon from "feather-icons-react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import TruckIcon from "../../assets/images/svg/Truck.svg";
import Location from "../../assets/images/svg/Location.svg";
import Route from "../../assets/images/svg/route.svg";
import Fuel from "../../assets/images/svg/fuel.svg";
import Plus from "../../assets/images/svg/plus.svg";
import Human from "../../assets/images/svg/Human.svg";
import { useNavigate } from "react-router-dom";

export const RealTimeMap = ({ data, mapRef, focusOnMarker }) => {
  const [activeTab, setActiveTab] = useState("State");
  const navigate = useNavigate();

  const handleOpenInNewTab = () => {
    navigate("/map-view");
  };

  const toggleViewDetailModal = (data) => {
    setTripDetails(data);
    setViewDetails(!viewDetails);
  };
  const getCustomIcon = (url) =>
    new L.Icon({
      iconUrl: url || TruckIcon,
      iconSize: [34, 34],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
      className: "leaflet-truck-icon",
    });

  return (
    <Card className="realTimeTripCard h-100">
      <CardBody className="d-flex flex-column h-100">
        <Button className="tripMapButton" onClick={handleOpenInNewTab}>
          Open in Full Map View
        </Button>

        <div className="map-wrapper" style={{ flex: 1 }}>
          <MapContainer
            center={[45.4654, 9.1859]}
            ref={mapRef}
            zoom={6}
            scrollWheelZoom={true}
            zoomControl={false}
            whenCreated={(mapInstance) => {
              mapRef.current = mapInstance;
            }}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {data.map((trip, index) => {
              const icon = getCustomIcon(trip.icon_url);

              return (
                <Marker
                  key={index}
                  position={[trip.lat, trip.lng]}
                  icon={icon}
                  eventHandlers={{
                    mouseover: (e) => {
                      e.target.openPopup();
                    },
                    mouseout: (e) => {
                      e.target.closePopup();
                    },
                    click: () => {
                      focusOnMarker(trip.lat, trip.lng);
                    },
                  }}
                >
                  <Popup
                    closeButton={false}
                    autoPan={false}
                    className="leaflet-popup-content-wrapper"
                  >
                    <div className="leaflet-popup-content">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex gap-2">
                          <div className="popup-index-box">29</div>
                          <div className="popup-index-content">
                            <h5>Cebotari Gicu (FG598RC)</h5>
                            <span>1000007491960</span>
                          </div>
                        </div>

                        <FeatherIcon
                          icon="x"
                          size={16}
                          className="CrossIcon"
                          onClick={() => mapRef.current.closePopup()}
                          style={{
                            cursor: "pointer",
                            marginRight: "10px",
                            marginTop: "0px",
                            width: "24px",
                            height: "24px",
                          }}
                        />
                      </div>
                    </div>

                    <div className="activeTabContent activeTabContainer">
                      <Nav tabs className="headerTabs_Map_Container">
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              setActiveTab("State");
                            }}
                            className={
                              activeTab === "State" ? "active-tab" : ""
                            }
                          >
                            State
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              setActiveTab("Write");
                            }}
                            className={
                              activeTab === "Write" ? "active-tab" : ""
                            }
                          >
                            Write
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            onClick={() => {
                              setActiveTab("Indications");
                            }}
                            className={
                              activeTab === "Indications" ? "active-tab" : ""
                            }
                          >
                            Indications
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            onClick={() => {
                              setActiveTab("Ad POI");
                            }}
                            className={
                              activeTab === "Ad POI" ? "active-tab" : ""
                            }
                          >
                            Ad POI
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>

                    {activeTab === "State" ? (
                      <div>
                        <div className="d-flex align-items-start gap-2 popup-state-section">
                          <img
                            src={Location}
                            alt=""
                            className="popup-state-section-img"
                          />

                          <div>
                            <span className="popup-state-section-1">
                              15-050202516:30
                            </span>
                            <br />
                            <span className="popup-state-section-2">
                              E76, 55011 Capannori LU, Italy
                            </span>
                            <br />
                            <span className="popup-state-section-3">
                              On the move85.6km/h -Km Odometer: 1.021.963.6
                            </span>
                          </div>
                        </div>

                        <div className="d-flex align-items-start gap-2 popup-icon-row">
                          <img
                            src={Route}
                            alt=""
                            className="popup-icon-row-img"
                          />
                          <div>
                            {/* Row 1 */}
                            <div className="d-flex justify-content-between gap-2">
                              <span className="notifyLabel">
                                Driver commitment hours:
                              </span>
                              <span className="notifyValue">08:00</span>
                            </div>

                            {/* Row 2 */}
                            <div className="d-flex justify-content-between">
                              <span className="notifyLabel">
                                Driver driving hours:
                              </span>
                              <span className="notifyValue">
                                05:55 - 380.9 Km
                              </span>
                            </div>

                            {/* Row 3 */}
                            <div className="d-flex justify-content-between">
                              <span className="notifyLabel">
                                Remaining guide:
                              </span>
                              <span className="notifyValue">to rest 04:05</span>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2 popup-icon-row">
                          <img
                            src={Fuel}
                            alt=""
                            style={{ width: "24px", height: "24px" }}
                          />
                          <div>
                            <span
                              style={{
                                fontWeight: "600",
                                fontSize: "12px",
                                color: "#161616",
                              }}
                            >
                              Show nearby stations
                            </span>
                          </div>
                        </div>

                        <div className="d-flex  align-items-center gap-3 popUp-icons-item">
                          <div className="d-flex align-items-center gap-3">
                            <img
                              src={Plus}
                              alt="Plus icon"
                              style={{ width: "24px", height: "24px" }}
                            />
                            <span className="popup-detail-item span">
                              DetailPathStreet
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <img
                              src={Human}
                              alt="Human icon"
                              style={{ width: "24px", height: "24px" }}
                            />
                            <span className="popup-detail-item span">
                              DetailPathStreet
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </Popup>
                </Marker>
              );
            })}
          </MapContainer>
        </div>
      </CardBody>
    </Card>
  );
};
